import React, { useState , useEffect} from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import configData from '../../temp/config';
import './component-header.css'
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';

const ComponentHeader = (props) => {
  const [componentData, setComponentData] = useState({})

  useEffect(() => {
    setComponentData(props.fields);
    // checkDropDown();
  }, [])

    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //---------------------------------------------

  return (
    <div className="heading-section-common-header">
      {/* <p>ComponentHeader Component</p> */}
      {componentData.topLogo && <>
        {/* <img src={`${configData.sitecoreApiHost}${componentData.topLogo.value.src}`} alt="" /> */}
        <h1>{componentData.title.value}</h1>
      </>}
    </div>
  )
}

export default ComponentHeader;
